/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const MeetingPage = lazyLoad(
  () => import('./index'),
  module => module.MeetingPage
);
